import { useContext } from 'react';
import Button from 'components/gruenland/atoms/button/Button';
import Typography from 'components/gruenland/atoms/typography';
import { AccountContext } from 'context/account';
import useBottomSectionProps from '../hooks/useBottomSectionProps';

type ThankYouFooterProps = {
  loading: boolean;
};

const ThankYouFooter: React.FC<ThankYouFooterProps> = ({ loading }) => {
  const { loggedIn } = useContext(AccountContext);

  const { bottomSectionProps } = useBottomSectionProps(loggedIn);

  return (
    <div className="grid border-b border-neutral-400 pb-6 pt-4 md:border-b-0 lg:pb-0 lg:pt-9">
      <Typography
        as="h3"
        className="mb-4 w-fit leading-[20px] text-primary-black md:mb-6 md:text-[18px] md:leading-normal lg:text-[22px]"
        asSkeleton={loading}
      >
        {bottomSectionProps?.title}
      </Typography>
      <Typography className="mb-6 w-fit text-[14px] text-secondary-black md:text-[16px]" asSkeleton={loading}>
        {bottomSectionProps?.subtitle}
      </Typography>
      <Button
        className="w-full py-2 md:w-fit md:px-[56px] md:py-3"
        asSkeleton={loading}
        onClick={bottomSectionProps.onClick}
      >
        {bottomSectionProps?.cta}
      </Button>
    </div>
  );
};

export default ThankYouFooter;
